import { render } from "./ModalProductDiscount.vue?vue&type=template&id=dc34fd96"
import script from "./ModalProductDiscount.vue?vue&type=script&lang=js"
export * from "./ModalProductDiscount.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__